// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1ceep5n0 {
  background-color: var(--_18w76bw27);
  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwz);
  flex-direction: column;
  width: var(--_18w76bw1s);
  gap: var(--_18w76bwh);
  margin-left: auto;
  margin-right: auto;
}
._1ceep5n1 {
  flex-direction: column;
  padding: var(--_18w76bw9);
  background-color: var(--_18w76bw25);
  width: var(--_18w76bw1w);
}
._1ceep5n2 {
  padding: var(--_18w76bwg) var(--_18w76bwy);
  line-height: var(--_18w76bw47);
  border-bottom: 1px solid var(--_18w76bw2a);
  width: var(--_18w76bw1w);
}
._1ceep5n3 {
  padding: var(--_18w76bwh) var(--_18w76bwy) var(--_18w76bw9);
  gap: var(--_18w76bwg);
  flex-direction: column;
}
._1ceep5n4 {
  padding-bottom: var(--_18w76bwi);
  border-bottom: 1px solid var(--_18w76bw2a);
}
._1ceep5n5 {
  flex-direction: column;
  padding: var(--_18w76bwh) var(--_18w76bwy) var(--_18w76bwg);
  gap: var(--_18w76bwg);
  width: var(--_18w76bw1w);
  margin-top: auto;
}
._1ceep5n6 {
  padding-bottom: var(--_18w76bwg);
  padding-left: var(--_18w76bwg);
}
._1ceep5n7 {
  width: var(--_18w76bw1w);
}
._1ceep5n7:hover {
  text-decoration: none;
}
._1ceep5n8 {
  line-height: var(--_18w76bw46);
  color: var(--_18w76bw33);
  border-bottom: 1px solid var(--_18w76bw33);
  text-decoration: none;
}
._1ceep5n8:hover {
  text-decoration: none;
}
@media screen and (max-width: 767px) {
  ._1ceep5n0 {
    padding-top: var(--_18w76bw9);
    padding-bottom: var(--_18w76bws);
    width: var(--_18w76bw1w);
    margin-left: var(--_18w76bw9);
    margin-right: var(--_18w76bw9);
    gap: var(--_18w76bwd);
  }
  ._1ceep5n1 {
    padding: var(--_18w76bw9);
    height: var(--_18w76bw1v);
    margin: var(--_18w76bw9);
    width: var(--_18w76bw1w);
    min-height: var(--_18w76bw1v);
  }
  ._1ceep5n2 {
    padding: var(--_18w76bwg);
  }
  ._1ceep5n3 {
    padding: var(--_18w76bwh) var(--_18w76bwg) var(--_18w76bw9);
  }
  ._1ceep5n4 {
    padding-bottom: var(--_18w76bwh);
  }
  ._1ceep5n5 {
    padding: var(--_18w76bwh) var(--_18w76bwh) var(--_18w76bwd);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,2DAA2D;EAC3D,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;EACE,2DAA2D;EAC3D,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,2DAA2D;EAC3D,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,0CAA0C;EAC1C,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,gCAAgC;EAClC;EACA;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["._1ceep5n0 {\n  background-color: var(--_18w76bw27);\n  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwz);\n  flex-direction: column;\n  width: var(--_18w76bw1s);\n  gap: var(--_18w76bwh);\n  margin-left: auto;\n  margin-right: auto;\n}\n._1ceep5n1 {\n  flex-direction: column;\n  padding: var(--_18w76bw9);\n  background-color: var(--_18w76bw25);\n  width: var(--_18w76bw1w);\n}\n._1ceep5n2 {\n  padding: var(--_18w76bwg) var(--_18w76bwy);\n  line-height: var(--_18w76bw47);\n  border-bottom: 1px solid var(--_18w76bw2a);\n  width: var(--_18w76bw1w);\n}\n._1ceep5n3 {\n  padding: var(--_18w76bwh) var(--_18w76bwy) var(--_18w76bw9);\n  gap: var(--_18w76bwg);\n  flex-direction: column;\n}\n._1ceep5n4 {\n  padding-bottom: var(--_18w76bwi);\n  border-bottom: 1px solid var(--_18w76bw2a);\n}\n._1ceep5n5 {\n  flex-direction: column;\n  padding: var(--_18w76bwh) var(--_18w76bwy) var(--_18w76bwg);\n  gap: var(--_18w76bwg);\n  width: var(--_18w76bw1w);\n  margin-top: auto;\n}\n._1ceep5n6 {\n  padding-bottom: var(--_18w76bwg);\n  padding-left: var(--_18w76bwg);\n}\n._1ceep5n7 {\n  width: var(--_18w76bw1w);\n}\n._1ceep5n7:hover {\n  text-decoration: none;\n}\n._1ceep5n8 {\n  line-height: var(--_18w76bw46);\n  color: var(--_18w76bw33);\n  border-bottom: 1px solid var(--_18w76bw33);\n  text-decoration: none;\n}\n._1ceep5n8:hover {\n  text-decoration: none;\n}\n@media screen and (max-width: 767px) {\n  ._1ceep5n0 {\n    padding-top: var(--_18w76bw9);\n    padding-bottom: var(--_18w76bws);\n    width: var(--_18w76bw1w);\n    margin-left: var(--_18w76bw9);\n    margin-right: var(--_18w76bw9);\n    gap: var(--_18w76bwd);\n  }\n  ._1ceep5n1 {\n    padding: var(--_18w76bw9);\n    height: var(--_18w76bw1v);\n    margin: var(--_18w76bw9);\n    width: var(--_18w76bw1w);\n    min-height: var(--_18w76bw1v);\n  }\n  ._1ceep5n2 {\n    padding: var(--_18w76bwg);\n  }\n  ._1ceep5n3 {\n    padding: var(--_18w76bwh) var(--_18w76bwg) var(--_18w76bw9);\n  }\n  ._1ceep5n4 {\n    padding-bottom: var(--_18w76bwh);\n  }\n  ._1ceep5n5 {\n    padding: var(--_18w76bwh) var(--_18w76bwh) var(--_18w76bwd);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
